import { fromLonLat } from 'ol/proj';
import { FARM_LAT, FARM_LON } from '../../config/env';
import { useMapContext } from '../../map/MapContext';
import { MeasureToolbar } from '../MeasureToolbar/MeasureToolbar';
import { ViewToggle2D3D } from '../ViewToggle2D3D/ViewToggle2D3D';
import { CompassIcon, HomeIcon } from '../icons/Icons';
import { Tooltip } from '../Tooltip/Tooltip';
import './bottom-toolbar.css';

const INITIAL_ZOOM = 15;

/**
 * Floating bottom toolbar pill — layout modeled on a reference UI/UX
 * pattern the user shared (layout inspiration only, no borrowed branding).
 * Combines the measurement tools, a reset-view action, the 2D/3D toggle and
 * the Compare toggle (both moved out of the top bar per that reference's
 * layout), and a stub accent action, in one dark rounded pill.
 */
export function BottomToolbar() {
  const { map, compareMode, setCompareMode } = useMapContext();

  function resetView() {
    map.getView().animate({ center: fromLonLat([FARM_LON, FARM_LAT]), zoom: INITIAL_ZOOM, duration: 300 });
  }

  return (
    <div className="bottom-toolbar">
      <MeasureToolbar />

      <div className="bottom-toolbar-divider" />

      <Tooltip heading="Reset view" description="Return to the default map extent.">
        <button type="button" className="bottom-toolbar-icon-btn" onClick={resetView} aria-label="Reset view">
          <HomeIcon />
        </button>
      </Tooltip>

      <ViewToggle2D3D />

      <Tooltip
        heading={compareMode ? 'Exit compare' : 'Compare'}
        description={compareMode ? 'Return to single-date viewing.' : 'Compare two dates with a swipe slider.'}
      >
        <button
          type="button"
          className={`bottom-toolbar-compare${compareMode ? ' active' : ''}`}
          onClick={() => setCompareMode(!compareMode)}
        >
          {compareMode ? 'Exit compare' : 'Compare'}
        </button>
      </Tooltip>

      <div className="bottom-toolbar-divider" />

      <Tooltip heading="Locate" description="Not available yet.">
        <button type="button" className="bottom-toolbar-accent-btn" aria-label="Locate">
          <CompassIcon />
        </button>
      </Tooltip>
    </div>
  );
}
